import { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Components
import { ReactComponent as MlbPlayIconLight } from '../../../assets/svgs/mlbplay-logo-vertical-light.svg';
import SEO from '../../SEO/SEO';

// Hooks
import { useAdobeTracking } from '../../../hooks';
import { translate } from '../../../configs';

const StyledNotFound = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 1rem;
  text-align: center;

  p {
    margin: 0 0 1rem 0;
  }
`;
const SmallBaseBallEmoji = styled.span`
  font-size: 0.5rem;
`;
const HeaderOne = styled.h1`
  font-size: 2.625rem;
  margin: 0 0 1rem 0;
`;
const HeaderTwo = styled.h1`
  font-size: 1.625rem;
`;
const IconContainer = styled.a`
  svg {
    width: 8rem;
    height: auto;
  }
`;

const notFoundText = translate('404NotFound');

export const NotFound = () => {
  const { trackClick, trackPageView } = useAdobeTracking();
  const handleBackToHubClick = () => {
    trackClick({
      type: 'Game Hub',
      subType: '404 error',
      event: 'link game hub click',
      eventText: 'Game Hub',
      eventIndex: '0',
      targetURL: 'https://www.mlb.com/play',
    });
  };

  const handleContactSupportClick = () => {
    trackClick({
      type: 'Game Hub',
      subType: '404 error',
      event: 'link customer support click',
      eventText: 'Customer Support',
      eventIndex: '1',
      targetURL: 'https://www.mlb.com/official-information/contact',
    });
  };

  // adobe analytics page view
  useEffect(() => {
    trackPageView({ type: 'Game Hub', subType: '404 Error' });
  }, [trackPageView]);
  // end adobe analytics page view

  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <SEO title="404 Error Page" description={''} />
      <StyledNotFound>
        <HeaderOne>
          {translate('weDroppedTheBall')}
          <SmallBaseBallEmoji role="presentation" aria-hidden="true">
            ⚾️
          </SmallBaseBallEmoji>
        </HeaderOne>
        <p>{translate('youHaveReachedThisPageInError')}</p>
        <p>
          {translate('pleaseTryTheActionAgain')}{' '}
          <a
            href={`${window.location.origin}/play`}
            onClick={handleBackToHubClick}
          >
            {translate('gameHub')}
          </a>
          . {translate('ifTheProblemContinues')}{' '}
          <a
            href={`https://mlb.com/official-information/contact`}
            onClick={handleContactSupportClick}
          >
            {translate('customerSupport')}
          </a>
          .
        </p>
        <HeaderTwo aria-label={notFoundText}>{notFoundText}</HeaderTwo>
        <IconContainer
          href={`${window.location.origin}/play`}
          onClick={handleBackToHubClick}
        >
          <MlbPlayIconLight />
        </IconContainer>
      </StyledNotFound>
    </motion.div>
  );
};

export default NotFound;
